const Dashboard = () => import("../layouts/dashboard.vue");
const ListClientB2b = () => import("../pages/client/listClient.vue");
const DetailClientB2b = () => import("../pages/client/detailClient.vue");
const ListDiscount = () => import("../pages/discountTable/listDiscount.vue");
/**
 * @type {import('vue-router').RouteConfig[]}
 */
export const clientRoute = [
  {
    path: "/cliente",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        component: ListClientB2b,
      },
      {
        path: ":id/detalhe",
        component: DetailClientB2b,
      },
      {
        path: "tabela-desconto",
        component: ListDiscount,
      },
    ],
  },
];
